import { ArrowBackIos, ArrowForwardIos, Pause, PlayArrow } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useRef, useState } from 'react';

export const PostImages = ({imgs}) => {
  let placeholder_img = 'https://storage.googleapis.com/events.makegayfriends.com/event_images/uploads/logo.svg'

  const [index, setActiveStep] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true)
  const videoRef = useRef(null)

      // Function to go to the next picture
    const goToNextPicture = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const goToPrevPicture = () => {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const togglePlay = () => {
        const el = videoRef.current
        if (!el) return
        if (el.paused) { el.play(); setIsPlaying(true) }
        else { el.pause(); setIsPlaying(false) }
    }

    let img = imgs[index]

    return (
      <>
      <div style={{width:'100%', margin:'auto'}}>
        {imgs.length > index+1 && <IconButton style={{top:"40%", float:'right'}} onClick={goToNextPicture}><ArrowForwardIos /></IconButton>}
        {index > 0 && <IconButton style={{top:"40%"}} onClick={goToPrevPicture}><ArrowBackIos /></IconButton>}
        {img?.url.includes("mp4") ?
        <div style={{placeContent:'center', display:'flex', position:'relative'}}>
            <video
                ref={videoRef}
                key={img?.url}
                autoPlay
                muted
                loop
                playsInline
                onClick={togglePlay}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
                style={{width:'100%', maxHeight:'70vh', borderRadius:14, boxShadow:'0 6px 20px rgba(0,0,0,0.18)', background:'#000'}}
            >
            <source src={img?.url} type="video/mp4" />
            </video>
            <div
                onClick={togglePlay}
                style={{
                    position: 'absolute',
                    bottom: 8,
                    right: 8,
                    width: 34,
                    height: 34,
                    borderRadius: '50%',
                    background: 'rgba(0,0,0,0.5)',
                    backdropFilter: 'blur(6px)',
                    color: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'background 0.15s ease',
                }}
                onMouseOver={e => e.currentTarget.style.background = 'rgba(0,0,0,0.7)'}
                onMouseOut={e => e.currentTarget.style.background = 'rgba(0,0,0,0.5)'}
            >
                {isPlaying ? <Pause fontSize="small" /> : <PlayArrow fontSize="small" />}
            </div>
        </div>
        :
        <img
            srcSet={img?.url}
            src={img?.url}
            alt="post"
            style={{width:"100%", height:"100%"}}
            onLoad={e => {
                if(e.target.height < 10) e.target.src = placeholder_img
            }}
            onError={(e) => {
                e.target.style.textAlign = 'center';
                e.target.style.background = 'url('+placeholder_img+')';
                e.target.style.backgroundSize = 'contain';
                e.target.style.backgroundRepeat = 'no-repeat';
                if(e.currentTarget.src !== placeholder_img)
                    e.target.src = placeholder_img
                }}
        />
        }

      </div>
      </>
    )
}
